var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kaidanHome"},[(!_vm.isshow)?_c('SettlementCenter'):_vm._e(),(_vm.isshow)?_c('KDjs'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }